/* DashProof – motion and interaction layer. Enhances existing markup only. */
(function () {
  if (window.dpxReady) return;
  window.dpxReady = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;

  /* scroll progress + header state + back to top */
  const progress = document.createElement('div');
  progress.className = 'dpx-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.appendChild(progress);

  const toTop = document.createElement('button');
  toTop.type = 'button';
  toTop.className = 'dpx-top';
  toTop.setAttribute('aria-label', 'Back to top');
  toTop.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
  /* the page can scroll on the window or on .page-wrapper (e.g. in theme preview) */
  const wrapper = document.querySelector('.page-wrapper');
  function scroller() {
    return wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 && getComputedStyle(wrapper).overflowY !== 'visible' ? wrapper : null;
  }

  toTop.addEventListener('click', () => {
    const behavior = reduced ? 'auto' : 'smooth';
    const el = scroller();
    if (el) el.scrollTo({ top: 0, behavior });
    window.scrollTo({ top: 0, behavior });
  });
  document.body.appendChild(toTop);

  const aboutImg = document.querySelector('.dp-about__img img');
  let ticking = false;

  function onScroll() {
    ticking = false;
    const el = scroller();
    const y = el ? el.scrollTop : window.scrollY;
    const max = el ? el.scrollHeight - el.clientHeight : root.scrollHeight - window.innerHeight;
    progress.style.transform = `scaleX(${max > 0 ? y / max : 0})`;
    root.classList.toggle('dpx-scrolled', y > 40);
    toTop.classList.toggle('dpx-show', y > 700);

    if (aboutImg && !reduced) {
      const r = aboutImg.parentElement.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        const k = 1 - (r.top + r.height) / (window.innerHeight + r.height);
        aboutImg.style.transform = `translateY(${-k * 8}%) scale(1.1)`;
      }
    }
  }
  document.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScroll);
    }
  }, { passive: true, capture: true });
  onScroll();

  /* cart bubble bump when the count changes */
  const bubble = document.querySelector('#header-component .cart-bubble');
  if (bubble) {
    new MutationObserver(() => {
      bubble.classList.remove('dpx-bump');
      void bubble.offsetWidth;
      bubble.classList.add('dpx-bump');
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* hero (home page banner) */
  const hero = document.querySelector('.template-index [id*="__hero_"], [id*="__hero_jVaWmY"]');
  if (hero && !reduced) {
    hero.classList.add('dpx-hero');
    const container = hero.querySelector('.hero__container');
    if (container) {
      if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
      const mouse = document.createElement('span');
      mouse.className = 'dpx-mouse';
      mouse.setAttribute('aria-hidden', 'true');
      container.appendChild(mouse);
    }
  }

  /* entrance effects replay each time a section comes back into view:
     shown once it is well inside the viewport, reset once fully out of it */
  function replayOnView(elements, cls, showOptions) {
    const show = new IntersectionObserver((entries) => {
      for (const e of entries) if (e.isIntersecting) e.target.classList.add(cls);
    }, showOptions);
    const hide = new IntersectionObserver((entries) => {
      for (const e of entries) if (!e.isIntersecting) e.target.classList.remove(cls);
    }, { threshold: 0 });
    for (const el of elements) {
      show.observe(el);
      hide.observe(el);
    }
  }

  /* scroll reveal (product section left untouched) */
  if (!reduced && 'IntersectionObserver' in window) {
    if (hero) replayOnView([hero], 'dpx-in', { threshold: 0.3 });
    const targets = document.querySelectorAll([
      '.dp-split .dp-split__grid > *',
      '.dp-split .dp-list li',
      '.dp-steps .dp-eyebrow', '.dp-steps .dp-h', '.dp-steps .dp-lead', '.dp-step',
      '.dp-about__grid > *',
      '.dp-blog__head', '.dp-post',
      '.dp-faq__grid > *'
    ].join(','));
    const groups = new Map();
    for (const el of targets) {
      const parent = el.parentElement;
      const i = groups.get(parent) || 0;
      groups.set(parent, i + 1);
      el.classList.add('dpx-rv');
      el.style.transitionDelay = `${Math.min(i, 4) * 0.12}s`;
    }
    replayOnView(targets, 'dpx-in', { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    replayOnView(document.querySelectorAll('.dp-trust:not(.dp-trust--scroll)'), 'dpx-pop', { threshold: 0.4 });
  }

  /* video slider: fill the active dot with playback progress */
  document.querySelectorAll('[data-dp-vslider]').forEach((slider) => {
    const dots = slider.querySelectorAll('[data-dot]');
    slider.querySelectorAll('.dp-vslider__slide').forEach((slide, i) => {
      const video = slide.querySelector('video');
      const dot = dots[i];
      if (!video || !dot) return;
      video.addEventListener('timeupdate', () => {
        if (video.duration) dot.style.setProperty('--dpx-p', `${(video.currentTime / video.duration) * 100}%`);
      });
      video.addEventListener('play', () => dots.forEach((d) => d !== dot && d.style.setProperty('--dpx-p', '0%')));
    });
  });

  /* FAQ: smooth open/close, one answer open at a time */
  document.querySelectorAll('.dp-faq details').forEach((details) => {
    const summary = details.querySelector('summary');
    const answer = details.querySelector('.dp-faq__a');
    if (!summary || !answer || reduced) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (details.dataset.dpxAnimating) return;

      if (details.open) {
        close(details);
      } else {
        details.parentElement.querySelectorAll('details[open]').forEach(close);
        details.open = true;
        const h = answer.scrollHeight;
        answer.animate([{ height: '0px', opacity: 0 }, { height: `${h}px`, opacity: 1 }], { duration: 350, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
    });
  });

  function close(details) {
    const answer = details.querySelector('.dp-faq__a');
    details.dataset.dpxAnimating = '1';
    const anim = answer.animate([{ height: `${answer.offsetHeight}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 300, easing: 'cubic-bezier(.2,.7,.2,1)' });
    anim.onfinish = () => {
      details.open = false;
      delete details.dataset.dpxAnimating;
    };
  }
})();
